import React from 'react';

import { useTranslations } from 'next-intl';

import { P } from '@/components/shared/Typography';
import { Progress } from '@/components/ui/progress';
import { C_DECIMAL_PLACES } from '@/ts/constants/C_DECIMAL_PLACES';

interface I_PoolProgressProps {
  percentage: number;
  availableTokensCount?: string;
}

export function PoolProgress({
  percentage,
  availableTokensCount
}: I_PoolProgressProps) {
  const t = useTranslations('pools');

  return (
    <div className="w-full flex flex-col gap-2.5">
      <Progress value={percentage} className="h-4" />
      <div className="flex justify-between items-center">
        <P className="text-sm font-medium">{t('availableTokens')}</P>
        <P className="text-sm font-medium">
          {availableTokensCount ? `${availableTokensCount} ` : ''}(
          {percentage.toFixed(C_DECIMAL_PLACES)}%)
        </P>
      </div>
    </div>
  );
}
